export default "__VITE_ASSET__D7hb_XI8__";